// Generated TypeScript interfaces for model

export interface Profession {
  id: number;
  label: string;
  identifier: ProfessionIdentifier;
}

export enum ProfessionIdentifier {
  DOCTOR = "DOK",
  NURSE = "SSK",
  ASSISTANT_NURSE = "USK",
  SOCIOLOGIST = "SOCIONOM",
  OCCUPATIONAL_THERAPIST = "ARBT",
  PHYSIOTHERAPIST = "FYS"
}

